<div class="text-bg-highlight text-xlarge bg-red mb-3">"{{atgardatNamn}}"</div>

<ng-container *ngFor="let record of records">
    <div class="mt-3">
        <i class="fas fa-user"></i><span class="ms-2">{{record.anvandare_id ? record.anvandare_id : 'Okänd användare'}}</span>
        <span class="ms-2 text-gray">{{ record.created | date:'yyyy-MM-dd'}}</span>
    </div>
    <p class="text-bg-highlight mt-2 mas-comment">{{record.kommentar}}</p>
</ng-container>

<form [formGroup]="commentForm">
    <div class="d-flex flex-column mb-3">
        <textarea formControlName="comment" type="text" rows="3" pInputTextarea></textarea>
        <p-button
            class="mt-3"
            styleClass="w-100"
            label="Lägg till kommentar"
            icon="fas fa-pen"
            (click)="addComment()"
            [loading]="loading"
            [disabled]="commentForm.pristine || !commentForm.valid">
        </p-button>
    </div>
</form>
